module.exports = __webpack_public_path__ + "media/img/clients/client7-51f1ccb51f5be4840d80483ff547f310.svg";